module.exports = __webpack_public_path__ + "static/media/myAvatar.a13c860f.png";